<div [formGroup]="form">
  <div class="form-spacing">
    <!-- Data richiesta (View only) -->
    <div class="column">
      <label class="label">{{ 'pre-employment.selfservice.declaration-date.label' | translate }}</label>
      <p class="text-dark">{{ form.get('createdAt')?.value | date: 'dd/MM/yyyy' }}</p>
    </div>

    <!-- Note (View only) -->
    <div class="column">
      <p
        class="text-dark"
        [innerHTML]="'selfservice-request.bank-details-change.display-notes.fallback.label' | translate"
      ></p>
    </div>

    <!-- Ho preso visione delle note -->
    <div class="row gap-small">
      <p-checkbox inputId="notesAcknowledged" formControlName="notesAcknowledged" binary="true"></p-checkbox>
      <label for="notesAcknowledged" class="row gap-small">
        <span>
          {{ 'selfservice-request.bank-details-change.notes-accepted.label' | translate }}
          <span class="mr-1 text-red-500">*</span>
        </span>
      </label>
    </div>
    @if (form.get('notesAcknowledged')?.invalid && form.get('notesAcknowledged')?.touched) {
      <small class="text-red-500 p-error">
        {{ 'selfservice-request.bank-details-change.notes-accepted-required' | translate }}
      </small>
    }

    <!-- Tipologia pagamento (View only, forced to MAIN) -->
    <div class="column">
      <label class="label" for="paymentType">
        {{ 'selfservice-request.bank-details-change.payment-type.label' | translate }}
        <span class="mr-1 text-red-500">*</span>
      </label>
      <input
        pInputText
        id="paymentType"
        [value]="_paymentKindsOptions[0].label"
        placeholder="{{ 'selfservice-request.bank-details-change.payment-type.label' | translate }}"
        class="full-width"
        [readonly]="true"
      />
    </div>

    <!-- Metodo di pagamento -->
    <div class="column">
      <label for="kind" class="label">
        {{ 'selfservice-request.bank-details-change.payment-method.label' | translate }}
        <span class="mr-1 text-red-500">*</span>
        <span class="cursor-pointer italic" [pTooltip]="kindTooltipContent" tooltipPosition="right">
          <i class="pi pi-question-circle"></i>
        </span>
        <ng-template #kindTooltipContent>
          <span [innerHTML]="'selfservice-request.bank-details-change.payment-method.tooltip' | translate"> </span>
        </ng-template>
      </label>
      <p-select
        inputId="kind"
        formControlName="kind"
        [options]="_kindOptions"
        placeholder="{{ 'selfservice-request.bank-details-change.payment-method.placeholder' | translate }}"
        class="full-width"
        appendTo="body"
        (onChange)="onChangePaymentMethod()"
      ></p-select>
      @if (form.get('kind')?.invalid && form.get('kind')?.touched) {
        <small class="text-red-500 p-error">
          {{ 'selfservice-request.bank-details-change.payment-method-required' | translate }}
        </small>
      }
    </div>

    <ng-container formGroupName="accountHolder">
      <!-- Nome intestatario -->
      <div class="column">
        <label for="holderFirstName" class="label">
          {{ 'selfservice-request.bank-details-change.holder-first-name.label' | translate }}
          <span class="mr-1 text-red-500">*</span>
        </label>
        <input
          id="holderFirstName"
          pInputText
          inputId="holderFirstName"
          formControlName="firstName"
          placeholder="{{ 'selfservice-request.bank-details-change.holder-first-name.placeholder' | translate }}"
        />
        @if (
          form.get('accountHolder')?.get('firstName')?.invalid && form.get('accountHolder')?.get('firstName')?.touched
        ) {
          <small class="text-red-500 p-error">
            {{ 'selfservice-request.bank-details-change.holder-first-name-required' | translate }}
          </small>
        }
      </div>

      <!-- Cognome intestatario -->
      <div class="column">
        <label for="holderLastName" class="label">
          {{ 'selfservice-request.bank-details-change.holder-last-name.label' | translate }}
          <span class="mr-1 text-red-500">*</span>
        </label>
        <input
          id="holderLastName"
          pInputText
          inputId="holderLastName"
          formControlName="lastName"
          placeholder="{{ 'selfservice-request.bank-details-change.holder-last-name.placeholder' | translate }}"
        />
        @if (
          form.get('accountHolder')?.get('lastName')?.invalid && form.get('accountHolder')?.get('lastName')?.touched
        ) {
          <small class="text-red-500 p-error">
            {{ 'selfservice-request.bank-details-change.holder-last-name-required' | translate }}
          </small>
        }
      </div>
    </ng-container>

    @if (form.get('kind')?.value === BankDetailsChangePaymentMethod.BANK_TRANSFER) {
      <ng-container formGroupName="accountCoHolder">
        <!-- Nome cointestatario -->
        <div class="column">
          <label for="coHolderFirstName" class="label">{{
            'selfservice-request.bank-details-change.co-holder-first-name.label' | translate
          }}</label>
          <input
            id="coHolderFirstName"
            pInputText
            inputId="coHolderFirstName"
            formControlName="firstName"
            placeholder="{{ 'selfservice-request.bank-details-change.co-holder-first-name.placeholder' | translate }}"
          />
        </div>

        <!-- Cognome cointestatario -->
        <div class="column">
          <label for="coHolderLastName" class="label">{{
            'selfservice-request.bank-details-change.co-holder-last-name.label' | translate
          }}</label>
          <input
            id="coHolderLastName"
            pInputText
            inputId="coHolderLastName"
            formControlName="lastName"
            placeholder="{{ 'selfservice-request.bank-details-change.co-holder-last-name.placeholder' | translate }}"
          />
        </div>
      </ng-container>
    }

    @if (form.get('kind')?.value === BankDetailsChangePaymentMethod.BANK_TRANSFER) {
      <!-- IBAN -->
      <div class="column">
        <label for="iban" class="label">
          {{ 'selfservice-request.bank-details-change.iban.label' | translate }}
          <span class="mr-1 text-red-500">*</span>
          <span class="cursor-pointer italic" [pTooltip]="ibanTooltipContent" tooltipPosition="right">
            <i class="pi pi-question-circle"></i>
          </span>
          <ng-template #ibanTooltipContent>
            <span [innerHTML]="'selfservice-request.bank-details-change.iban.tooltip' | translate"> </span>
          </ng-template>
        </label>
        <input
          id="iban"
          pInputText
          inputId="iban"
          formControlName="iban"
          placeholder="{{ 'selfservice-request.bank-details-change.iban.placeholder' | translate }}"
          class="full-width"
        />
        @if (form.get('iban')?.invalid && form.get('iban')?.touched) {
          <small class="text-red-500 p-error">
            {{ 'selfservice-request.bank-details-change.iban-required' | translate }}
          </small>
        }
      </div>

      <!-- ABI -->
      <div class="column">
        <label for="abi" class="label">
          {{ 'selfservice-request.bank-details-change.abi.label' | translate }}
          <span class="mr-1 text-red-500">*</span>
        </label>
        <input id="abi" pInputText inputId="abi" [value]="abi()" class="full-width" />
      </div>

      <!-- CAB -->
      <div class="column">
        <label for="cab" class="label">
          {{ 'selfservice-request.bank-details-change.cab.label' | translate }}
          <span class="mr-1 text-red-500">*</span>
        </label>
        <input id="cab" pInputText inputId="cab" [value]="cab()" class="full-width" />
      </div>
    }
  </div>
</div>
